import AddIcon from "@mui/icons-material/AddRounded";
import type { SxProps, Theme } from "@mui/material";
import { Box, Button } from "@mui/material";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import type { ConditionField, DimensionDescriptor } from "../../../../../../../../../api/types/svTypes.ts";
import { createCurrentReportAction } from "../../../../../store/utils/storeUtils";
import { createEmptyConditionItem } from "../../utilities/createEmptyConditionItem";
import CustomMeasureDimensionSelection from "./CustomMeasureDimensionSelection";

interface Props {
  text: string;
  conditions: ConditionField[] | undefined;
  dimensions: DimensionDescriptor[];
  sx?: SxProps<Theme>;
  onAddField: (field: ConditionField) => void;
}
export default function AddCustomMeasureConditions({ text, conditions, dimensions, onAddField, sx }: Props) {
  const dispatch = useDispatch();
  const [addConditionAnchorEl, setAddConditionAnchorEl] = useState<HTMLElement | null>(null);
  const [showAddConditions, setShowAddConditions] = useState(false);

  const conditionSelection = useMemo(() => {
    if (conditions === undefined) return dimensions;
    return dimensions.filter((f) => !conditions.some((fs) => f.name === fs.meta.name));
  }, [conditions, dimensions]);

  if (conditionSelection.length === 0) return null;

  return (
    <Box sx={sx}>
      <Button
        ref={setAddConditionAnchorEl}
        sx={{
          lineHeight: "20px",
          letterSpacing: "0.14px",
          fontSize: "12px",
          textWrap: "nowrap",
          height: "30px",
        }}
        startIcon={<AddIcon />}
        onClick={() => setShowAddConditions(true)}
      >
        {text}
      </Button>
      {addConditionAnchorEl && showAddConditions && (
        <CustomMeasureDimensionSelection
          anchorEl={addConditionAnchorEl}
          dimensions={conditionSelection}
          onClose={(value) => {
            if (value !== undefined) {
              const field = createEmptyConditionItem(structuredClone(value));
              onAddField(field);
              dispatch(createCurrentReportAction("setAutoShowItemOptionsId", field.config.guid));
            }
            setShowAddConditions(false);
          }}
        />
      )}
    </Box>
  );
}
